import { ChangeDetectorRef, Directive } from '@angular/core';
import { Focusable } from './../interfaces/focusable';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validator, FormControl, NG_VALIDATORS } from '@angular/forms';
import { forwardRef, InjectionToken, Type, HostListener, Input } from '@angular/core';

// @Directive()
export abstract class AbstractCustomControl<T> implements ControlValueAccessor, Validator, Focusable {
    constructor(protected changeDetectorRef: ChangeDetectorRef){
    }

    _value: T;
    _oldValue: T;
    
    onChange = (_) => {};
    onTouched = () => {};

    get value(): T {
        return this._value;
    }

    set value(v: T){
        if(this._value !== v){
            //this._oldValue = this._value;
            this._value = v;
            this.onChange(v);
        }
    }
    get oldValue(): T {
      return this._oldValue;
    }

    set oldValue(v: T) {
      if (this._oldValue !== v) {
        //this._oldValue = this._value;
        this._oldValue = v;
        this.onChange(v);
      }
    }

    writeValue(value: T){
        if(value !== undefined){
            this._value = value;
            this._oldValue = value;
        }
    }

    registerOnChange(fn: (_: any) => void){
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouched = fn;
    }

    public validate(c: FormControl) {
        return null;
    }

    setDisabledState(isDisabled: boolean){
        this.isDisabled = isDisabled;
    }

    @HostListener('focusin', ['$event'])
    onFocus(event: FocusEvent){
        //alert('got focus');
        //console.log(target);
        //setTimeout(function(){
        if(!this.isDisabled){
            this.isActive = true;
            this.changeDetectorRef.detectChanges();
            //console.log('is active');
        //}, 1000);
            if(event.target instanceof HTMLDivElement)
                this.focus();
            //event.cancelBubble = true;
            //console.log('abstract control focus in' + event.target);
        }
    }

    @HostListener('focusout', ['$event.target'])
    onFocusOut(target: any){
        this.isActive = false;
        this.changeDetectorRef.detectChanges();
    }

    isActive: boolean = false;
    isDisabled: boolean = false;
    @Input() Label: string;
    @Input() TabStopOnButtons: boolean = false;
    @Input() set disabled(value: boolean){
        this.setDisabledState(value);
    }

    focus(){
        //this.isActive = true;
    }
}

export function MakeProvider(type: any){
    return {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => type),
        multi: true
    }
}

export function MakeValidator(type: any){
    return {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => type),
        multi: true
    }
}
